import React from "react";
import "./loaderIcon.css";

function LoaderIcon() {
  return (
    <div className="loader-icon-wrapper">
      <i className="fas fa-spinner fa-spin"></i>
    </div>
  );
}

export default LoaderIcon;
